/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { 
  styled,
  Typography,
  Button,
  Box,
  TextField,
  IconButton,
 } from "@mui/material";

export const RestaurantGroupContainer = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

export const StyledTitleContainer = styled('div')({
  padding: '20px 0px 10px 0px',
})

export const StyledTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: '700',
  lineHeight: '40px',
})

export const StyledCreateButton = styled(Button)({
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
})

export const StyledCancelButton = styled(Button)({
  '&:hover': {
    textTransform: 'none',
    fontWeight: '600',
    boxShadow: 'none',
    border: '2px solid #001b59',
    borderRadius: '8px',
    color: '#001b59',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  border: '2px solid #395bbd',
  borderRadius: '8px',
  color: '#395bbd',
})

export const StyledAddButton = styled(Button)({
  '&.Mui-disabled':{
    backgroundColor: '#001b59',
  },
  '&:hover': {
    textTransform: 'none',
    fontWeight: '600',
    boxShadow: 'none',
    backgroundColor: '#001b59',
    borderRadius: '8px',
    padding: '0px 30px',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  backgroundColor: '#395bbd',
  borderRadius: '8px',
  padding: '0px 30px',
})

export const StyledButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '15px 20px 5px 20px',
})

export const StyledCreateTitle = styled(Typography)({
  fontSize: '34px',
  fontWeight: '700',
  marginTop: '10px',
  textAlign: 'center',
  wordWrap: 'break-word',
})

export const StyledFormContainer = styled('div')({
  marginTop: '10%',
  paddingBottom: '130px',
})

export const StyledFormFieldText = styled(Typography)({
  fontWeight: '600 !important',
  fontSize: '15px !important',
  marginBottom: '5px',
  color: 'rgba(81, 81, 82, 1);'
})

export const StyledTextField = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '2px solid #395bbd !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '8px'
  },
})

export const StyledLogoSection = styled(Box)({
  marginTop: '24px',
  padding: '18px',
  border: '1px solid #e5e7eb',
  borderRadius: '16px',
  background: 'linear-gradient(180deg, #ffffff 0%, #fafafa 100%)',
})

export const StyledLogoSectionHeader = styled(Typography)({
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '26px',
})

export const StyledLogoSectionSubheader = styled(Typography)({
  fontSize: '13px',
  color: '#6b7280',
  marginTop: '6px',
})

export const StyledLogoGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: '16px',
  marginTop: '18px',
})

export const StyledLogoCard = styled(Box)({
  padding: '14px',
  border: '1px solid #e5e7eb',
  borderRadius: '14px',
  backgroundColor: '#fff',
})

export const StyledLogoPreviewFrame = styled(Box)({
  width: '100%',
  minHeight: '188px',
  padding: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '12px',
  border: '1px solid #e5e7eb',
  boxSizing: 'border-box',
})

export const StyledLogoPreview = styled('img')({
  width: '100%',
  height: '100%',
  maxHeight: '150px',
  objectFit: 'contain',
})

export const StyledLogoPreviewFallback = styled(Box)({
  minHeight: '150px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '16px',
  color: '#6b7280',
  fontSize: '14px',
  fontWeight: 600,
  borderRadius: '10px',
  backgroundColor: 'rgba(255, 255, 255, 0.72)',
})

export const StyledRequirementList = styled('ul')({
  margin: '10px 0 0 18px',
  padding: 0,
})

export const StyledRequirementItem = styled('li')({
  color: '#4b5563',
  fontSize: '12px',
  marginBottom: '4px',
})

export const StyledLogoActions = styled(Box)({
  display: 'flex',
  gap: '8px',
  marginTop: '12px',
  flexWrap: 'wrap',
})

export const StyledSharedRequirements = styled(Box)({
  marginTop: '14px',
  padding: '14px 16px',
  borderRadius: '12px',
  border: '1px solid #e5e7eb',
  backgroundColor: '#fff',
})

export const StyledGoldBackgroundSection = styled(Box)({
  marginTop: '14px',
  paddingTop: '14px',
  borderTop: '1px solid #e5e7eb',
})

export const StyledColorChipGrid = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  gap: '10px',
  marginTop: '12px',
})

export const StyledColorChipWrapper = styled(Box)({
  position: 'relative',
  width: '112px',
  flex: '0 0 112px',
})

export const StyledColorChip = styled('button', {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'colorValue',
})(({ selected, colorValue }) => ({
  position: 'relative',
  minHeight: '72px',
  width: '100%',
  borderRadius: '12px',
  border: selected ? '2px solid #395bbd' : '1px solid #d1d5db',
  background: colorValue,
  cursor: 'pointer',
  padding: '8px',
  boxShadow: selected ? '0 0 0 3px rgba(57, 91, 189, 0.16)' : 'none',
}))

export const StyledColorChipDeleteButton = styled(IconButton)({
  position: 'absolute',
  top: '4px',
  right: '4px',
  zIndex: 1,
  width: '22px',
  height: '22px',
  backgroundColor: 'transparent',
  border: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent',
  },
})

export const StyledColorChipLabel = styled(Box)({
  position: 'absolute',
  left: '8px',
  bottom: '8px',
  padding: '4px 6px',
  borderRadius: '999px',
  backgroundColor: 'rgba(255, 255, 255, 0.88)',
  color: '#111827',
  fontSize: '11px',
  fontWeight: 700,
})

export const StyledColorEditorRow = styled(Box)({
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
  marginTop: '14px',
  flexWrap: 'wrap',
})
